import React, {useState} from 'react'
import RenderFields from "../../../common/ui/render-fields";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import _ from "lodash";
import {SEARCH_TARGETING_INPUT_FIELDS} from "../../constants/targeting.constant";

const emptyFilterCriteria: any = {};
let allFilterFields = _.groupBy(SEARCH_TARGETING_INPUT_FIELDS, 'group')['filter'];
// allFilterFields = _.concat(allFilterFields, _.groupBy(TARGETING_INPUT_FIELDS, 'group')['pagination']);
// const defaultSelectedField = {name: 'targetingType', value: 'module'};

const TargetingFilters = ({filterCriteria, setFilterCriteria}) => {
    const [targetingFilterFields, setTargetingFilterFields] = useState(prepareInputFields(allFilterFields, null, filterCriteria));

    const handleFilterChanges = (event) => {
        const existingFilterCriteria = {...filterCriteria};
        handleFieldValueChanges(event, existingFilterCriteria, setFilterCriteria);
    }

    const clearFilterCriteria = () => {
        setFilterCriteria(emptyFilterCriteria);
    }

    return (
        <>
            <div className="flex flex-wrap justify-start w-full">
                <RenderFields
                    parentForm={filterCriteria}
                    handleDetailChanges={handleFilterChanges}
                    fieldList={targetingFilterFields}
                    enableEdit={true}
                    fieldClassName={`mr-2`}/>

                {targetingFilterFields.length > 0 &&
                    <div className="w-40">
                        <button
                            onClick={() => clearFilterCriteria()}
                            className="button-gray-outline mt-10 px-2 py-1">
                            Clear Filters
                        </button>
                    </div>
                }

            </div>
        </>
    )
}

export default TargetingFilters
